import { render, staticRenderFns } from "./verifyAddressManully.vue?vue&type=template&id=c845b5bc&"
import script from "./verifyAddressManully.vue?vue&type=script&lang=js&"
export * from "./verifyAddressManully.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports